import type { FireSafetyEmptyStateTranslations } from "../../types/fireSafetyEmptyState";

export const fireSafetyEmptyState: FireSafetyEmptyStateTranslations = {
  title: "Fire Safety Information Not Set Up",
  description:
    "Set up fire safety information to track your building's fire prevention and emergency response systems.",
  bulletHeading: "Important Safety Systems to Track:",
  bullets: [
    "Fire alarm systems",
    "Sprinkler systems",
    "Emergency lighting",
    "Fire extinguishers",
    "Evacuation routes",
  ],
  setupButton: "Set Up Fire Safety Information",
};
